module.exports = __webpack_public_path__ + "static/media/hero.abfab35e.jpg";